/* Plug & Play native theme: site-wide features beyond cart/PDP/collection (theme.js).
   Header overlay state, home sections, help pages and forms, brands, wishlist, recently viewed,
   colour swatches, accessibility widget, cookie notice + Shopify Customer Privacy API. */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = () => matchMedia("(prefers-reduced-motion: reduce)").matches || document.documentElement.classList.contains("a11y-stop-motion");
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (_) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} },
  };

  /* ---------------- T-shirt edits (?edit=white|icons|de-coeur|relaxed), port of CollectionPageView ---------------- */
  const edits = $("[data-tshirt-edits]");
  if (edits) {
    const edit = new URLSearchParams(location.search).get("edit") || "";
    $$("[data-edit]", edits).forEach((a) => { const on = a.dataset.edit === edit; a.classList.toggle("active", on); if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current"); });
    if (edit) {
      const test = {
        white: (t) => /^#f{3}(?:f{3})?$|^white$|לבן/i.test(t.dataset.color) || /white/i.test(t.dataset.text),
        icons: (t) => ["AMI PARIS", "COLE BUXTON", "DAILY PAPER", "REPRESENT"].includes(t.dataset.vendor.toUpperCase()),
        "de-coeur": (t) => /de coeur/i.test(t.dataset.text),
        relaxed: (t) => /oversized|relaxed|loose|boxy/i.test(t.dataset.text),
      }[edit];
      if (test) {
        let n = 0;
        const own = $$("[data-grid] > [data-tile]");
        const banner = $("[data-grid] > .collection-fill-banner");
        const ownTiles = banner ? own.filter((t) => t.compareDocumentPosition(banner) & Node.DOCUMENT_POSITION_FOLLOWING) : own;
        ownTiles.forEach((t) => { const ok = test(t); t.hidden = !ok; if (ok) n++; });
        if (banner) {
          // top the page up to 24 like live: banner + related products
          const fillTiles = $$("[data-grid] > [data-tile], [data-grid] > .pp-fill-extra").filter((t) => !ownTiles.includes(t));
          const room = 24 - n - 1;
          banner.hidden = room <= 0;
          fillTiles.forEach((t, i) => (t.hidden = i >= room));
        }
        const count = $(".curated-collection-count");
        if (count) count.textContent = `${n} ITEMS`;
        $$("[data-shown]").forEach((x) => (x.textContent = n));
      }
    }
  }

  /* ---------------- collection fill banner scrolls to the related products below it ---------------- */
  document.addEventListener("click", (e) => {
    const banner = e.target.closest("[data-fill-banner]");
    if (!banner) return;
    let next = banner.nextElementSibling;
    const top = banner.getBoundingClientRect().top;
    while (next && next.getBoundingClientRect().top <= top + 10) next = next.nextElementSibling;
    const header = $("header")?.getBoundingClientRect().height || 0;
    scrollTo({ top: (next || banner).getBoundingClientRect().top + scrollY - header - 16, behavior: reduced() ? "auto" : "smooth" });
  });

  /* ---------------- The Edit: 12 stories per page (?page=n), like the live magazine ---------------- */
  const mag = $("[data-magazine-grid]");
  if (mag) {
    const cards = [...mag.children];
    const pages = Math.ceil(cards.length / 12);
    const page = Math.min(pages, Math.max(1, Number(new URLSearchParams(location.search).get("page")) || 1));
    cards.forEach((c, i) => (c.hidden = Math.floor(i / 12) + 1 !== page));
    const nav = $("[data-magazine-nav]");
    let html = "";
    for (let n = 1; n <= pages; n++) html += `<a ${n === page ? 'aria-current="page" class="active" ' : ""}aria-label="עמוד ${n}" href="?page=${n}">${n}</a>`;
    if (page < pages) html += `<a aria-label="לעמוד הבא" href="?page=${page + 1}">→</a>`;
    nav.innerHTML = html;
  }

  /* ---------------- overlay header (home, about, help pages) ---------------- */
  const header = $("[data-site-header][data-header-appearance=overlay]");
  if (header) {
    let scrolled = false, hovered = false;
    const announce = header.dataset.announce === "true";
    const paint = () => {
      const dark = scrolled || hovered || header.matches(":focus-within") || !!$("[data-menu]:not([hidden]),[data-search]:not([hidden]),[data-cart-drawer]:not([hidden])");
      header.classList.toggle("site-header-dark", dark);
      header.classList.toggle("site-header-light", !dark);
      header.classList.toggle("site-header-scrolled", scrolled);
      header.classList.toggle("site-header-hovered", !scrolled && hovered);
      header.classList.toggle("top-0", scrolled || !announce);
      header.classList.toggle("top-9", !scrolled && announce);
      header.dataset.headerState = dark ? "dark" : "light";
    };
    const onScroll = () => {
      const y = scrollY;
      scrolled = y <= 2 ? false : y > 8 ? true : scrolled;
      paint();
    };
    addEventListener("scroll", onScroll, { passive: true });
    header.addEventListener("mouseenter", () => { hovered = true; paint(); });
    header.addEventListener("mouseleave", () => { hovered = false; paint(); });
    header.addEventListener("focusin", paint);
    header.addEventListener("focusout", () => setTimeout(paint, 0));
    document.addEventListener("click", () => setTimeout(paint, 0));
    onScroll();
  }

  /* ---------------- home: hero carousel ---------------- */
  $$("[data-hero]").forEach((hero) => {
    const slides = $$(".campaign-slide", hero);
    const dots = $$("[data-hero-dot]", hero);
    if (slides.length < 2) return;
    let i = 0, timer;
    const ms = (Number(hero.dataset.interval) || 6) * 1000;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle("is-active", on);
        s.setAttribute("aria-hidden", !on);
        s.inert = !on;
        const img = $("img", s);
        if (on && img) img.loading = "eager";
        const a = $("a", s);
        if (a) a.tabIndex = on ? 0 : -1;
      });
      dots.forEach((d, k) => {
        d.classList.toggle("is-active", k === i);
        d.setAttribute("aria-selected", k === i);
        const f = $(".campaign-dot-fill", d);
        if (f) { f.dataset.running = "false"; if (k === i) requestAnimationFrame(() => (f.dataset.running = "true")); }
      });
      clearTimeout(timer);
      if (!reduced()) timer = setTimeout(() => go(i + 1), ms);
    };
    dots.forEach((d) => d.addEventListener("click", () => go(Number(d.dataset.heroDot))));
    if (!reduced()) timer = setTimeout(() => go(1), ms);
    // warm the next slide once the page is idle
    (window.requestIdleCallback || setTimeout)(() => { const img = $("img", slides[1]); if (img) img.loading = "eager"; });
  });

  /* ---------------- home: product rails ---------------- */
  $$("[data-rail-section]").forEach((sec) => {
    const rail = $("[data-rail]", sec);
    const prev = $("[data-rail-prev]", sec);
    const next = $("[data-rail-next]", sec);
    if (!rail || !prev) return;
    const step = () => (rail.children[0] ? rail.children[0].getBoundingClientRect().width : rail.clientWidth);
    const update = () => {
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    prev.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: reduced() ? "auto" : "smooth" }));
    next.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: reduced() ? "auto" : "smooth" }));
    rail.addEventListener("scroll", update, { passive: true });
    update();
  });

  /* ---------------- home: today's look ---------------- */
  $$("[data-look]").forEach((look) => {
    const panels = $$(".todays-look-product-panel", look);
    const dots = $$("[data-look-dot]", look);
    let i = 0;
    const go = (n) => {
      i = (n + panels.length) % panels.length;
      panels.forEach((p, k) => { p.classList.toggle("is-active", k === i); p.setAttribute("aria-hidden", k !== i); p.inert = k !== i; });
      dots.forEach((d, k) => d.setAttribute("aria-current", k === i));
    };
    dots.forEach((d) => d.addEventListener("click", () => go(Number(d.dataset.lookDot))));
    $("[data-look-prev]", look)?.addEventListener("click", () => go(i - 1));
    $("[data-look-next]", look)?.addEventListener("click", () => go(i + 1));
  });

  /* ---------------- help pages: side navigation is open on desktop (HelpNavigation) ---------------- */
  const helpNav = $$(".brand-contact-navigation");
  if (helpNav.length) {
    const desk = matchMedia("(min-width: 1000px)");
    const sync = () => helpNav.forEach((d) => (d.open = desk.matches));
    sync();
    desk.addEventListener("change", sync);
  }

  /* ---------------- help pages: FAQ accordions ---------------- */
  document.addEventListener("click", (e) => {
    const b = e.target.closest(".brand-help-accordion button[aria-controls]");
    if (!b) return;
    const panel = document.getElementById(b.getAttribute("aria-controls"));
    const open = b.getAttribute("aria-expanded") !== "true";
    b.setAttribute("aria-expanded", open);
    if (panel) panel.inert = !open;
  });

  /* ---------------- help forms: choices, conditional fields, validation ---------------- */
  const PHONE = /^0\d{8,9}$/;
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function formValues(box) {
    const v = {};
    $$("[data-field]", box).forEach((el) => (v[el.dataset.field] = el.value.trim()));
    return v;
  }
  function errorsFor(kind, v) {
    const e = {};
    if (v.name !== undefined && v.name.length < 2) e.name = "נא להזין שם מלא";
    if (v.phone !== undefined && !PHONE.test(v.phone.replace(/[\s-]/g, ""))) e.phone = kind === "contact" ? "נא להזין מספר טלפון ישראלי תקין" : "נא להזין מספר טלפון תקין";
    if (v.email !== undefined && !EMAIL.test(v.email)) e.email = kind === "contact" ? "נא להזין כתובת אימייל תקינה" : "נא להזין אימייל תקין";
    if (kind === "contact") {
      if (!v.reason) e.reason = "נא לבחור את סיבת הפנייה";
      if (v.reason === "הזמנות" && v.orderNumber.length < 4) e.orderNumber = "נא להזין מספר הזמנה תקין";
      if (v.reason && v.message.length < 10) e.message = "נא לפרט את הפנייה, לפחות 10 תווים";
    } else {
      if (v.orderNumber.length < 4) e.orderNumber = "נא להזין מספר הזמנה";
      if (kind === "returns-form") {
        if (!v.request) e.request = "נא לבחור את סוג הבקשה";
        if (v.request && !v.items) e.items = "נא לציין את הפריטים";
        if (v.request === "החלפה" && !v.replacement) e.replacement = "נא לציין פריט ומידה להחלפה";
        if (v.request === "החזרה" && !v.refund) e.refund = "נא לבחור אפשרות החזר";
        if (v.request === "החזרה" && v.message.length < 10) e.message = "נא לפרט את הבקשה, לפחות 10 תווים";
      }
    }
    return e;
  }
  function showErrors(box, errs, touched) {
    $$("[data-field]", box).forEach((el) => {
      const f = el.dataset.field;
      const field = el.closest(".brand-contact-field") || el.parentElement;
      let msg = $(".brand-contact-error[data-for]", field);
      const err = touched[f] && errs[f];
      const target = el.type === "hidden" ? $("[data-choice-trigger]", field) : el;
      if (target) target.setAttribute("aria-invalid", !!err);
      if (err) {
        if (!msg) { msg = document.createElement("p"); msg.className = "brand-contact-error"; msg.setAttribute("role", "status"); msg.dataset.for = f; field.appendChild(msg); }
        msg.textContent = err;
      } else if (msg) msg.remove();
    });
  }
  function conditional(box) {
    const v = formValues(box);
    $$("[data-show-when]", box).forEach((el) => {
      const [k, want] = el.dataset.showWhen.split("=");
      el.hidden = want === "*" ? !v[k] : v[k] !== want;
    });
  }
  $$("[data-pp-validate]").forEach((box) => {
    const form = box.closest("form");
    form.noValidate = true;
    const kind = box.dataset.ppValidate;
    const touched = {};
    const refresh = () => { conditional(box); showErrors(box, errorsFor(kind, formValues(box)), touched); };
    box.addEventListener("focusout", (e) => { const f = e.target.dataset && e.target.dataset.field; if (f) { touched[f] = true; refresh(); } });
    box.addEventListener("input", refresh);
    form.addEventListener("submit", (e) => {
      $$("[data-field]", box).forEach((el) => (touched[el.dataset.field] = true));
      const errs = errorsFor(kind, formValues(box));
      showErrors(box, errs, touched);
      if (Object.keys(errs).length) { e.preventDefault(); return; }
      // Shopify needs an email body; keep every answer in it.
      const body = form.querySelector('[name="contact[body]"]');
      if (body && !body.value.trim()) body.value = kind === "cancellation-form" ? "בקשה לביטול ההזמנה" : "—";
      const submit = $("button[type=submit]", form);
      if (submit) submit.textContent = kind === "contact" ? "שולח…" : "שולחים...";
    });
    // custom select like the live Radix select
    $$("[data-choice]", box).forEach((ch) => {
      const trigger = $("[data-choice-trigger]", ch);
      const list = $("[data-choice-list]", ch);
      const input = $("input[type=hidden]", ch);
      const label = $("[data-choice-value]", ch);
      const close = () => { list.hidden = true; trigger.setAttribute("aria-expanded", "false"); };
      trigger.addEventListener("click", () => { const o = list.hidden; list.hidden = !o; trigger.setAttribute("aria-expanded", o); if (o) $(".brand-contact-choice-item", list)?.focus(); });
      list.addEventListener("click", (e) => {
        const item = e.target.closest("[data-value]");
        if (!item) return;
        input.value = item.dataset.value;
        label.textContent = item.dataset.value;
        $$("[data-value]", list).forEach((x) => x.setAttribute("aria-selected", x === item));
        close();
        trigger.focus();
        if (kind === "returns-form" && input.dataset.field === "request") {
          ["items", "replacement", "refund", "message"].forEach((f) => { const el = $(`[data-field="${f}"]`, box); if (el) el.value = ""; delete touched[f]; });
          const refundCh = $('[data-field="refund"]', box)?.closest("[data-choice]");
          if (refundCh) { const l = $("[data-choice-value]", refundCh); l.textContent = l.dataset.placeholder; }
        }
        touched[input.dataset.field] = true;
        refresh();
      });
      list.addEventListener("keydown", (e) => {
        const items = $$("[data-value]", list);
        const cur = items.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); items[Math.min(items.length - 1, cur + 1)].focus(); }
        if (e.key === "ArrowUp") { e.preventDefault(); items[Math.max(0, cur - 1)].focus(); }
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); document.activeElement.click(); }
        if (e.key === "Escape") { close(); trigger.focus(); }
      });
      document.addEventListener("pointerdown", (e) => { if (!ch.contains(e.target)) close(); });
    });
    conditional(box);
  });

  /* ---------------- service pages with no backend yet (same messages as live) ---------------- */
  const giftForm = $(".gift-card-form");
  if (giftForm) {
    const amounts = $$(".gift-card-amounts button", giftForm);
    const submit = $("button[type=submit]", giftForm);
    amounts.forEach((b) => b.addEventListener("click", () => {
      amounts.forEach((x) => x.setAttribute("aria-pressed", x === b));
      submit.textContent = `לבחירת Gift Card · ${b.textContent.trim()}`;
    }));
    giftForm.addEventListener("submit", (e) => { e.preventDefault(); $(".service-status", giftForm).textContent = "רכישת ה־Gift Card תיפתח עם חיבור שירות הכרטיסים. אפשר לפנות אלינו ונשמח לעזור."; });
  }
  const giftBalance = $(".brand-help-gift form");
  if (giftBalance) {
    const input = $("#gift-number", giftBalance);
    let err = null;
    const setErr = (t) => {
      if (!err) { err = document.createElement("p"); err.id = "gift-error"; err.className = "brand-contact-error"; err.setAttribute("role", "alert"); $(".brand-help-gift-row", giftBalance).after(err); }
      err.textContent = t; input.setAttribute("aria-invalid", !!t); if (!t) { err.remove(); err = null; }
    };
    input.addEventListener("input", () => { input.value = input.value.replace(/\D/g, "").slice(0, 16).replace(/(.{4})/g, "$1 ").trim(); setErr(""); });
    giftBalance.addEventListener("submit", (e) => {
      e.preventDefault();
      const digits = input.value.replace(/\D/g, "");
      setErr(/^\d{16}$/.test(digits) ? "בדיקת היתרה תתאפשר לאחר הפעלת שירות Gift Card. פרטי השירות יעודכנו בהמשך." : "נא להזין מספר כרטיס בן 16 ספרות");
    });
  }
  const club = $(".club-page--join");
  if (club) {
    let register = false;
    const form = $("form", club);
    const extra = document.createElement("div");
    extra.hidden = true;
    extra.innerHTML = '<div class="club-form-row"><input name="firstName" aria-label="שם פרטי" placeholder="שם פרטי" autocomplete="given-name"><input name="lastName" aria-label="שם משפחה" placeholder="שם משפחה" autocomplete="family-name"></div><input name="email" type="email" aria-label="אימייל" placeholder="אימייל" autocomplete="email"><input name="city" aria-label="יישוב" placeholder="יישוב" autocomplete="address-level2"><label class="club-consent"><input name="consent" type="checkbox"> קראתי את <a href="/pages/club-member-policy">תקנון המועדון</a> ואת <a href="/pages/privacy">מדיניות הפרטיות</a></label><p class="club-form-note">פרטי החברות וההטבות של Plug &amp; Play יעודכנו לפני פתיחת המועדון.</p>';
    $("input[name=phone]", form).after(extra);
    const sw = $(".club-switch", club);
    sw?.addEventListener("click", () => {
      register = !register;
      extra.hidden = !register;
      $$("input", extra).forEach((i) => (i.required = register && i.name !== "city"));
      $("h1", club).textContent = register ? "הצטרפות למועדון" : "התחברות למועדון";
      $("h1 + p", club).textContent = register ? "כמה פרטים ונכיר טוב יותר" : "הזינו את מספר הטלפון להמשך התהליך";
      $(".club-submit", club).textContent = register ? "להצטרפות" : "המשך";
      $(".club-switch-label", club).textContent = register ? "כבר חברים במועדון?" : "עדיין לא חברים?";
      sw.textContent = register ? "התחברות" : "להצטרפות";
      $(".club-status", club).textContent = "";
    });
    form.addEventListener("submit", (e) => { e.preventDefault(); $(".club-status", club).textContent = "שירות המועדון ייפתח בקרוב. לפרטים אפשר לפנות לשירות הלקוחות."; });
  }

  /* ---------------- brands directory ---------------- */
  const brands = $("[data-brands]");
  if (brands) {
    let cat = "all";
    const saved = new Set(store.get("pnp-wishlist-brands", []));
    const search = $("[data-brand-search]", brands);
    const apply = () => {
      const q = search.value.trim().toLowerCase();
      const shown = new Set();
      $$("li[data-brand-name]", brands).forEach((li) => {
        const ok = li.dataset.brandName.includes(q) && (cat === "all" || li.dataset.cats.includes(cat));
        li.hidden = !ok;
        if (ok) shown.add(li.closest("[data-brand-group]").id);
      });
      $$("[data-brand-group]", brands).forEach((g) => (g.hidden = !shown.has(g.id)));
      $$("[data-brand-letter]", brands).forEach((a) => (a.hidden = !shown.has(`designer-${a.dataset.brandLetter}`)));
    };
    $$("[data-brand-cat]", brands).forEach((b) => b.addEventListener("click", () => {
      cat = b.dataset.brandCat;
      $$("[data-brand-cat]", brands).forEach((x) => x.setAttribute("aria-pressed", x === b));
      apply();
    }));
    search.addEventListener("input", apply);
    $$("[data-brand-save]", brands).forEach((b) => {
      const h = b.dataset.brandSave;
      const paint = () => { b.setAttribute("aria-pressed", saved.has(h)); $("span", b).textContent = saved.has(h) ? "−" : "+"; };
      paint();
      b.addEventListener("click", () => { saved.has(h) ? saved.delete(h) : saved.add(h); store.set("pnp-wishlist-brands", [...saved]); paint(); });
    });
  }

  /* ---------------- tiles fetched by handle (wishlist, recently viewed, swatches) ---------------- */
  async function tileHtml(handle, view) {
    const r = await fetch(`/products/${encodeURIComponent(handle)}?view=${view}`);
    if (!r.ok) return null;
    const html = (await r.text()).trim();
    return html.startsWith("<article") ? html : null;
  }

  /* wishlist page (handles saved by the heart buttons, theme.js key pp-wishlist) */
  const wl = $("[data-wishlist-page]");
  if (wl) {
    const render = async () => {
      const handles = store.get("pp-wishlist", []);
      $("[data-wishlist-count]", wl).textContent = handles.length;
      $("[data-wishlist-live]", wl).textContent = `${handles.length} פריטים ברשימת המועדפים`;
      $("[data-wishlist-empty]", wl).hidden = handles.length > 0;
      $("[data-wishlist-full]", wl).hidden = handles.length === 0;
      const grid = $("[data-wishlist-grid]", wl);
      const tiles = await Promise.all(handles.map((h) => tileHtml(h, "tile")));
      grid.innerHTML = tiles.filter(Boolean).join("");
      document.dispatchEvent(new CustomEvent("pp:tiles"));
    };
    $("[data-wishlist-clear]", wl).addEventListener("click", () => { store.set("pp-wishlist", []); render(); });
    $("[data-wishlist-share]", wl).addEventListener("click", async () => {
      const url = location.origin + "/pages/wishlist";
      try { if (navigator.share) await navigator.share({ title: "My Wishlist", url }); else { await navigator.clipboard.writeText(url); $("[data-wishlist-msg]", wl).textContent = "הקישור הועתק"; } } catch (_) {}
    });
    document.addEventListener("pp:wishlist", render);
    render();
  }

  /* recently viewed (same storage key as live: pnp.recent.v1) */
  const recent = $("[data-recent]");
  if (recent) {
    const handle = recent.dataset.handle;
    const prev = store.get("pnp.recent.v1", []).filter((h) => typeof h === "string");
    store.set("pnp.recent.v1", [handle, ...prev.filter((h) => h !== handle)].slice(0, 6));
    const show = prev.filter((h) => h !== handle).slice(0, 5);
    if (show.length) {
      const io = new IntersectionObserver(async (entries) => {
        if (!entries.some((x) => x.isIntersecting)) return;
        io.disconnect();
        const tiles = (await Promise.all(show.map((h) => tileHtml(h, "tile-plain")))).filter(Boolean);
        if (!tiles.length) return;
        recent.innerHTML = `<section class="section-y" aria-labelledby="recently-viewed-heading"><div class="mx-auto max-w-[1500px] px-6"><h2 id="recently-viewed-heading" class="text-center ">Recently Viewed</h2><div class="mt-10 grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-4">${tiles.join("")}</div></div></section>`;
        document.dispatchEvent(new CustomEvent("pp:tiles"));
      }, { rootMargin: "400px" });
      io.observe(recent);
    }
  }

  /* colour swatches on collection cards swap the card to that colour */
  document.addEventListener("click", async (e) => {
    const b = e.target.closest("[data-swatch-handle]");
    if (!b || b.getAttribute("aria-pressed") === "true") return;
    e.preventDefault();
    const tile = b.closest("[data-tile]");
    const html = await tileHtml(b.dataset.swatchHandle, "tile");
    if (!html || !tile) return;
    const holder = document.createElement("div");
    holder.innerHTML = html;
    const fresh = holder.firstElementChild;
    tile.replaceWith(fresh);
    document.dispatchEvent(new CustomEvent("pp:tiles"));
    $(`[data-swatch-handle="${b.dataset.swatchHandle}"]`, fresh)?.focus();
  });

  /* inline quick add on plain cards */
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-inline-toggle]");
    if (t) {
      const panel = t.parentElement.querySelector("[data-inline-panel]");
      const open = panel.hidden;
      panel.hidden = !open;
      t.setAttribute("aria-expanded", open);
      t.textContent = open ? "סגירת בחירת מידה" : "הוספה מהירה לסל";
    }
  });

  /* ---------------- accessibility widget (Israeli accessibility regulations) ---------------- */
  const A11Y = "pnp-a11y-prefs";
  const a11y = $(".accessibility-widget");
  if (a11y) {
    const DEF = { fontScale: 1, contrast: false, underline: false, stopMotion: false };
    let prefs = Object.assign({}, DEF, store.get(A11Y, {}));
    const panel = $("#a11y-panel", a11y);
    const toggle = $("[data-a11y-toggle]", a11y);
    const apply = () => {
      const r = document.documentElement;
      r.style.setProperty("--a11y-font-scale", String(prefs.fontScale));
      r.classList.toggle("a11y-contrast", prefs.contrast);
      r.classList.toggle("a11y-underline", prefs.underline);
      r.classList.toggle("a11y-stop-motion", prefs.stopMotion);
      $("[data-a11y-scale]", a11y).textContent = `${Math.round(prefs.fontScale * 100)}%`;
      $$("[data-a11y-pref]", a11y).forEach((b) => {
        const on = !!prefs[b.dataset.a11yPref];
        b.setAttribute("aria-pressed", on);
        b.classList.toggle("border-ink", on); b.classList.toggle("bg-ink", on); b.classList.toggle("text-paper", on);
        b.classList.toggle("border-line", !on); b.classList.toggle("hover:border-ink", !on);
        $(".latin", b).textContent = on ? "ON" : "OFF";
      });
    };
    const save = () => { store.set(A11Y, prefs); apply(); };
    const setOpen = (o) => { panel.hidden = !o; toggle.setAttribute("aria-expanded", o); };
    toggle.addEventListener("click", () => setOpen(panel.hidden));
    $("[data-a11y-close]", a11y).addEventListener("click", () => { setOpen(false); toggle.focus(); });
    $$("[data-a11y-font]", a11y).forEach((b) => b.addEventListener("click", () => {
      const d = Number(b.dataset.a11yFont) * 0.1;
      prefs.fontScale = Math.min(1.5, Math.max(0.9, +(prefs.fontScale + d).toFixed(2)));
      save();
    }));
    $$("[data-a11y-pref]", a11y).forEach((b) => b.addEventListener("click", () => { prefs[b.dataset.a11yPref] = !prefs[b.dataset.a11yPref]; save(); }));
    $("[data-a11y-reset]", a11y).addEventListener("click", () => { prefs = Object.assign({}, DEF); try { localStorage.removeItem(A11Y); } catch (_) {} apply(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.hidden) { setOpen(false); toggle.focus(); } });
    document.addEventListener("pointerdown", (e) => { if (!panel.hidden && !a11y.contains(e.target)) setOpen(false); });
    apply();
  }

  /* ---------------- cookie notice + Shopify Customer Privacy API ---------------- */
  const CONSENT = "pnp-cookie-consent";
  const DISMISS = "pnp-cookie-notice-dismissed";
  const readConsent = () => {
    let raw = null;
    try { raw = localStorage.getItem(CONSENT); } catch (_) {}
    if (!raw) { const m = document.cookie.match(/(?:^|; )pnp-cookie-consent=([^;]*)/); raw = m ? decodeURIComponent(m[1]) : null; }
    try { const p = JSON.parse(raw); return p && typeof p.decidedAt === "string" ? p : null; } catch (_) { return null; }
  };
  const pushToShopify = (analytics, marketing) => {
    const send = () => {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: !!analytics, marketing: !!marketing, preferences: true, sale_of_data: !!marketing },
          () => {}
        );
      } catch (_) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy) return send();
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (err) => { if (!err) send(); });
    }
  };
  const writeConsent = (analytics, marketing) => {
    const v = { necessary: true, analytics, marketing, decidedAt: new Date().toISOString() };
    const raw = JSON.stringify(v);
    try { localStorage.setItem(CONSENT, raw); } catch (_) {}
    document.cookie = `${CONSENT}=${encodeURIComponent(raw)}; path=/; max-age=31536000; SameSite=Lax`;
    window.dispatchEvent(new CustomEvent("pnp-cookie-consent-changed", { detail: v }));
    pushToShopify(analytics, marketing);
  };
  const cookie = $("[data-cookie]");
  const existing = readConsent();
  // Opt-out model (approved by the owner): tracking is granted until the visitor turns a category off.
  const syncDefault = () => pushToShopify(existing ? existing.analytics : true, existing ? existing.marketing : true);
  if (document.readyState === "complete") syncDefault(); else addEventListener("load", syncDefault);
  if (cookie) {
    const bar = $("[data-cookie-bar]", cookie);
    const prefsBox = $("[data-cookie-prefs]", cookie);
    const barCls = cookie.dataset.barClass.split(" ");
    const manCls = cookie.dataset.manageClass.split(" ");
    let opener = null;
    const manage = (on) => {
      bar.hidden = on;
      prefsBox.hidden = !on;
      cookie.setAttribute("aria-label", on ? "הגדרות עוגיות" : "הודעת עוגיות");
      barCls.forEach((c) => cookie.classList.toggle(c, !on));
      manCls.forEach((c) => cookie.classList.toggle(c, on));
      if (on) {
        const cur = readConsent();
        $("[data-cookie-analytics]", cookie).checked = cur ? cur.analytics : true;
        $("[data-cookie-marketing]", cookie).checked = cur ? cur.marketing : true;
        requestAnimationFrame(() => $("input:not([disabled]), button", prefsBox)?.focus());
      }
    };
    const close = () => { cookie.hidden = true; manage(false); opener?.focus?.(); opener = null; };
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS) === "1"; } catch (_) {}
    if (!existing && !dismissed) cookie.hidden = false;
    $("[data-cookie-manage]", cookie).addEventListener("click", () => manage(true));
    $$("[data-cookie-accept]", cookie).forEach((b) => b.addEventListener("click", () => { writeConsent(true, true); close(); }));
    $("[data-cookie-save]", cookie).addEventListener("click", () => { writeConsent($("[data-cookie-analytics]", cookie).checked, $("[data-cookie-marketing]", cookie).checked); close(); });
    $("[data-cookie-dismiss]", cookie).addEventListener("click", () => { try { sessionStorage.setItem(DISMISS, "1"); } catch (_) {} cookie.hidden = true; });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-cookie-settings]")) return;
      opener = e.target.closest("[data-cookie-settings]");
      cookie.hidden = false;
      manage(true);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape" || cookie.hidden || prefsBox.hidden) return;
      manage(false);
      if (readConsent()) close();
    });
  }
})();
